(function(){
    $(function () {
        // console.log("modal.js");

        let slide = $('#galleryModalSlide');
        let closeButton = $('#modalClose');
        let galleryModal = $('#galleryModal');
        let galleryImg = $('.gallery-img');

        let noticeModal = $('#noticeModal');

        // slide add
        slide.on('init', function(event, slick) {
            $(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
            $('.current').text(slick.currentSlide + 1);
            $('.total').text(slick.slideCount);
            // slide.slick("slickGoTo", 1, false);
        })

        slide.slick({
            dots: true,
            infinite: true,
            // adaptiveHeight: true,
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.current').text(nextSlide + 1);
        });

        // modal open  slide move
        galleryImg.on('click', function () {
            let imgNum = $(this).data('img-num');
            // console.log(imgNum);
            slide.slick("slickGoTo", imgNum, false);

            window.setTimeout(function(){
                galleryModal.addClass("modalShow");
            }, 500);
            // galleryModal.addClass("modalShow");
        });

        // modal close
        closeButton.on('click', function() {
            galleryModal.removeClass("modalShow");
        });
        $("#galleryBg").on('click', function() {
            galleryModal.removeClass("modalShow");
        });


        //------------------------------------------------
        // notice modal close
        $("#noticeModalBg").on('click', function () {
            noticeModal.removeClass("noticeShow");
        });
        $("#noticeModalCloseBtn").on('click', function () {
            noticeModal.removeClass("noticeShow");
        });




        ////////////////////////////////////////
        ////////////////////////////////////////
        ////////////////////////////////////////
        // yotube
        // indexで関数作ってやると、変数が取れなくなる？書き方？？
        // 急ぎなので、一旦index.htmlへ書き換え
        // var tag = document.createElement('script');
        // tag.src = "https://www.youtube.com/iframe_api";
        // var firstScriptTag = document.getElementsByTagName('script')[0];
        // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // let galleryMovie;
        // let $movieStartBtn = $("#galleryVideoIcon");
        // let done = false;

        // function onYouTubeIframeAPIReady() {
        //     galleryMovie = new YT.Player('galleryMovie', {
        //     height: '360',
        //     width: '640',
        //     playerVars: {
        //         controls: 0,
        //         rel: 0,
        //     },
        //     videoId: 'V1m1agwaXpA',
        //     events: {
        //         // 'onReady': onPlayerReady,
        //         // 'onStateChange': onPlayerStateChange
        //     }
        //     });
        // }

        // function onPlayerReady(event) {
        //     event.target.playVideo();
        // }
        // // function onPlayerStateChange(event) {
        // //     if (event.data == YT.PlayerState.PLAYING && !done) {
        // //     setTimeout(stopVideo, 6000);
        // //     done = true;
        // //     }
        // // }
        // function stopVideo() {
        //     galleryMovie.stopVideo();
        // }

        // //video icon click
        // $movieStartBtn.on('click', function () {
        //     $movieStartBtn.addClass("iconHide");
        //     // galleryMovie.playVideo();
        // });


    });
})();
